module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA1klEQVR4AWOgC7gjrwZHV1W0rzgZXDQ0uKWgDuSiIXQN11S07k4Ke9hs9KDb/lqcB2ENN9T0LiSoXq2Tudooe8nCAKcGFbs2CDoSmnEqI/ZYStGJ9ORD6bkwcQRC13B/8crHZWUPNmy8V1LyYPV6whruHT/78tTpp83tT3onPnz6iggbVm15vnbTm76Jz3sn3D98jrCGE8kR97J9n/VMeViUf6ksEKeG/zDw8ejW2wGCH159eDaj6V6yyn8MANeAAJ+373hW3/y6u/f385cENRAGDIMSAACfFwIaLqYJtwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/RS.png
// module id = 1252
// module chunks = 0